// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df80654e","455":"b61171ea","977":"659f290a"}[chunkId] + ".chunk.js";
};